import { render, staticRenderFns } from "./LogPanel.vue?vue&type=template&id=54d691a5"
import script from "./LogPanel.vue?vue&type=script&lang=ts"
export * from "./LogPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports